import React from 'react';
import { Field } from '@truvity/widget__forms';
import { ReadonlyField } from '@truvity/widget__forms-mui-theme';

import { CredentialCard } from './components/CredentialCard';

const notImplemented = () => {
    throw new Error('Not implemented');
};

export const ReadonlyLinkedCredential = (props: Field<string | undefined>) => (
    <ReadonlyField
        {...props}
        formatValue={(value) => <CredentialCard value={value} onDelete={notImplemented} isDisabled />}
    />
);
